import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'COMPANY_WEBHOOKS',
    itemActionName: 'COMPANY_WEBHOOK',
});
